import {
  Unit_instancev9v8hjid95df as Unit_instance,
  Unitkvevlwgzwiuc as Unit,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  HttpResponseValidator2d6ie1tmzg8fi as HttpResponseValidator,
  get_ExpectSuccessAttributeKey20jj5fup38v1g as get_ExpectSuccessAttributeKey,
} from './HttpCallValidator.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { save1y71vsgu0wj47 as save } from '../call/SavedCall.mjs';
import {
  bodyAsTextn7mkdszticiw as bodyAsText,
  HttpResponse1532ob1hsse1y as HttpResponse,
} from '../statement/HttpResponse.mjs';
import { MalformedInputExceptionbvc6h5ij0ias as MalformedInputException } from '../../../../../ktor-ktor-io/io/ktor/utils/io/charsets/Charset.js.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_ValidateMark() {
  _init_properties_DefaultResponseValidation_kt__wcn8vr();
  return ValidateMark;
}
var ValidateMark;
function get_LOGGER() {
  _init_properties_DefaultResponseValidation_kt__wcn8vr();
  return LOGGER;
}
var LOGGER;
function addDefaultResponseValidation(_this__u8e3s4) {
  _init_properties_DefaultResponseValidation_kt__wcn8vr();
  HttpResponseValidator(_this__u8e3s4, ($this$HttpResponseValidator) => {
    $this$HttpResponseValidator.e5o_1 = _this__u8e3s4.u5h_1;
    $this$HttpResponseValidator.f5o(addDefaultResponseValidation$lambda$slambda_0());
    return Unit_instance;
  });
}
var ResponseExceptionClass;
function ResponseException() {
  if (ResponseExceptionClass === VOID) {
    class $ extends IllegalStateException() {
      static l5o(response, cachedResponseText) {
        var $this = this.o('Bad response: ' + response.toString() + '. Text: "' + cachedResponseText + '"');
        captureStack($this, $this.k5o_1);
        $this.j5o_1 = response;
        return $this;
      }
    }
    initMetadataForClass($, 'ResponseException');
    ResponseExceptionClass = $;
  }
  return ResponseExceptionClass;
}
var RedirectResponseExceptionClass;
function RedirectResponseException() {
  if (RedirectResponseExceptionClass === VOID) {
    class $ extends ResponseException() {
      static t5o(response, cachedResponseText) {
        var $this = this.l5o(response, cachedResponseText);
        captureStack($this, $this.s5o_1);
        $this.r5o_1 = 'Unhandled redirect: ' + response.e5j().x5i().f5j().h51_1 + ' ' + response.e5j().x5i().g5j().toString() + '. ' + ('Status: ' + response.n5j().toString() + '. Text: "' + cachedResponseText + '"');
        delete $this.message;
        return $this;
      }
      r() {
        return this.r5o_1;
      }
      get message() {
        return this.r();
      }
    }
    initMetadataForClass($, 'RedirectResponseException');
    RedirectResponseExceptionClass = $;
  }
  return RedirectResponseExceptionClass;
}
var ClientRequestExceptionClass;
function ClientRequestException() {
  if (ClientRequestExceptionClass === VOID) {
    class $ extends ResponseException() {
      static b5p(response, cachedResponseText) {
        var $this = this.l5o(response, cachedResponseText);
        captureStack($this, $this.a5p_1);
        $this.z5o_1 = 'Client request(' + response.e5j().x5i().f5j().h51_1 + ' ' + response.e5j().x5i().g5j().toString() + ') ' + ('invalid: ' + response.n5j().toString() + '. Text: "' + cachedResponseText + '"');
        delete $this.message;
        return $this;
      }
      r() {
        return this.z5o_1;
      }
      get message() {
        return this.r();
      }
    }
    initMetadataForClass($, 'ClientRequestException');
    ClientRequestExceptionClass = $;
  }
  return ClientRequestExceptionClass;
}
var ServerResponseExceptionClass;
function ServerResponseException() {
  if (ServerResponseExceptionClass === VOID) {
    class $ extends ResponseException() {
      static j5p(response, cachedResponseText) {
        var $this = this.l5o(response, cachedResponseText);
        captureStack($this, $this.i5p_1);
        $this.h5p_1 = 'Server error(' + response.e5j().x5i().f5j().h51_1 + ' ' + response.e5j().x5i().g5j().toString() + ': ' + (response.n5j().toString() + '. Text: "' + cachedResponseText + '"');
        delete $this.message;
        return $this;
      }
      r() {
        return this.h5p_1;
      }
      get message() {
        return this.r();
      }
    }
    initMetadataForClass($, 'ServerResponseException');
    ServerResponseExceptionClass = $;
  }
  return ServerResponseExceptionClass;
}
var addDefaultResponseValidation$lambda$slambdaClass;
function addDefaultResponseValidation$lambda$slambda() {
  if (addDefaultResponseValidation$lambda$slambdaClass === VOID) {
    class $ {
      *k5p(response, $completion) {
        var expectSuccess = response.e5j().y5i().j4m(get_ExpectSuccessAttributeKey());
        if (!expectSuccess) {
          get_LOGGER().b4t('Skipping default response validation for ' + response.e5j().x5i().g5j().toString());
          return Unit_instance;
        }
        var statusCode = response.n5j().u53_1;
        var originCall = response.e5j();
        if (statusCode < 300 || originCall.y5i().l4m(get_ValidateMark())) {
          return Unit_instance;
        }
        // Inline function 'kotlin.apply' call
        var this_0 = yield* save(originCall, $completion);
        this_0.y5i().m4m(get_ValidateMark(), Unit_instance);
        var exceptionCall = this_0;
        var exceptionResponse = exceptionCall.c5h();
        var tmp;
        try {
          tmp = yield* bodyAsText(exceptionResponse, VOID, $completion);
        } catch ($p) {
          var tmp_0;
          if ($p instanceof MalformedInputException()) {
            var _unused_var__etf5q3 = $p;
            tmp_0 = '<body failed decoding>';
          } else {
            throw $p;
          }
          tmp = tmp_0;
        }
        var exceptionResponseText = tmp;
        var exception = (300 <= statusCode ? statusCode <= 399 : false) ? RedirectResponseException().t5o(exceptionResponse, exceptionResponseText) : (400 <= statusCode ? statusCode <= 499 : false) ? ClientRequestException().b5p(exceptionResponse, exceptionResponseText) : (500 <= statusCode ? statusCode <= 599 : false) ? ServerResponseException().j5p(exceptionResponse, exceptionResponseText) : ResponseException().l5o(exceptionResponse, exceptionResponseText);
        get_LOGGER().b4t('Default response validation for ' + response.e5j().x5i().g5j().toString() + ' failed with ' + exception.toString());
        throw exception;
      }
      ld(p1, $completion) {
        return this.k5p(p1 instanceof HttpResponse() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    addDefaultResponseValidation$lambda$slambdaClass = $;
  }
  return addDefaultResponseValidation$lambda$slambdaClass;
}
function addDefaultResponseValidation$lambda$slambda_0() {
  var i = new (addDefaultResponseValidation$lambda$slambda())();
  var l = (response, $completion) => i.k5p(response, $completion);
  l.$arity = 1;
  return l;
}
var properties_initialized_DefaultResponseValidation_kt_akvzqt;
function _init_properties_DefaultResponseValidation_kt__wcn8vr() {
  if (!properties_initialized_DefaultResponseValidation_kt_akvzqt) {
    properties_initialized_DefaultResponseValidation_kt_akvzqt = true;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'ValidateMark';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = getKClass(Unit());
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_0;
    try {
      tmp_0 = createKType(getKClass(Unit()), arrayOf([]), false);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    var tmp$ret$2 = tmp_0;
    var tmp$ret$1 = new (TypeInfo())(tmp, tmp$ret$2);
    ValidateMark = new (AttributeKey())(name, tmp$ret$1);
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.DefaultResponseValidation');
  }
}
//region block: exports
export {
  addDefaultResponseValidation as addDefaultResponseValidation1d06vtgr9flaj,
};
//endregion

//# sourceMappingURL=DefaultResponseValidation.mjs.map
